import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class QueryServiceGloblal {

  Login = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/login",payload);
  };
  Logout = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/logout",payload);
  };


}

const queryServiceGloblalInstance = new QueryServiceGloblal();

export default queryServiceGloblalInstance;
